import * as React from 'react';

// Media
const logoWhiteSVG = require('../../assets/logo/logo-white.svg');

// Components
import Paper from '../Paper';
import Typography from '../Typography';

// Style
import './EntryLayout.css';

//
export interface IProps {}

const EntryLayout: React.StatelessComponent<IProps> = props => {
  return (
    <div className="EntryLayout">
      <Paper className="EntryLayout__container">
        <div className="EntryLayout__typography">
          <div>
            <a href="/">
              <img src={logoWhiteSVG} />
            </a>
          </div>
          <div>
            <Typography
              type="display2"
              className="EntryLayout__typography__text"
              color="inherit"
            >
              Welcome
            </Typography>
            <Typography
              type="subheading"
              className="EntryLayout__typography__text"
              color="inherit"
            >
              Spotter is a modernized tool for collaborating smarter with focus
              on structure, speed, and design. Stay productive and efficient at
              scale.
            </Typography>
          </div>
          <div className="EntryLayout__typography__footer">
            <a href="https://cdn.spotter.bot/files/TermsAndConditions_24012016.pdf">
              Terms of agreement
            </a>
            <span />
            <a href="https://cdn.spotter.bot/files/PrivacyPolicy_24012016.pdf">
              Privacy
            </a>
          </div>
        </div>
        <div className="EntryLayout__children">{props.children}</div>
      </Paper>
    </div>
  );
};

export default EntryLayout;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Layout/EntryLayout.tsx